module.exports = __webpack_public_path__ + "static/media/extractive_services_law_grey.f025f9c3.svg";